  <div class="container-fluid sell_dash">
        <div class="wrapper">
            <div class="row">
              <app-sidemenu></app-sidemenu> 
              <section class="right">
              	<app-sellheader></app-sellheader>
              	<div class="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor" id="kt_content">
								<div class="kt-sc" style="background-image: url('assets/image/bg-9.jpg')">
									<div class="kt-container ">
										<div class="kt-sc__top">
											<h3 class="kt-sc__title">
												Help Center
											</h3>
											<div class="kt-sc__nav">
												<a href="#" class="kt-link kt-font-bold">Community</a>
												<a href="#" class="kt-link kt-font-bold">Visit Blog</a>
											</div>
										</div>
										<div class="kt-sc__bottom">
											<h3 class="kt-sc__heading kt-heading kt-heading--center kt-heading--xxl kt-heading--medium">
												How can we help?
											</h3>
											<form class="kt-sc__form">
												<div class="input-group">
													<div class="input-group-prepend">
														<span class="input-group-text" id="basic-addon1">
															<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
																<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
																	<rect x="0" y="0" width="24" height="24" />
																	<path d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z" fill="#000000" fill-rule="nonzero" opacity="0.3" />
																	<path d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z" fill="#000000" fill-rule="nonzero" />
																</g>
															</svg> </span>
													</div>
													<input type="text" class="form-control" placeholder="Ask a question" aria-describedby="basic-addon1">
												</div>
											</form>
										</div>
									</div>
								</div>

								<!-- end:: Hero -->

								<!-- begin:: Section -->
								<div class="kt-container ">
									<div class="row">
										<div class="col-lg-4">
											<div class="kt-portlet kt-iconbox kt-iconbox--animate-slow">
												<div class="kt-portlet__body">
													<a href="#" class="kt-iconbox__body">
														<div class="kt-iconbox__icon">
															<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
																<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
																	<rect x="0" y="0" width="24" height="24" />
																	<path d="M2.56066017,10.6819805 L4.68198052,8.56066017 C5.26776695,7.97487373 6.21751442,7.97487373 6.80330086,8.56066017 L8.9246212,10.6819805 C9.51040764,11.267767 9.51040764,12.2175144 8.9246212,12.8033009 L6.80330086,14.9246212 C6.21751442,15.5104076 5.26776695,15.5104076 4.68198052,14.9246212 L2.56066017,12.8033009 C1.97487373,12.2175144 1.97487373,11.267767 2.56066017,10.6819805 Z M14.5606602,10.6819805 L16.6819805,8.56066017 C17.267767,7.97487373 18.2175144,7.97487373 18.8033009,8.56066017 L20.9246212,10.6819805 C21.5104076,11.267767 21.5104076,12.2175144 20.9246212,12.8033009 L18.8033009,14.9246212 C18.2175144,15.5104076 17.267767,15.5104076 16.6819805,14.9246212 L14.5606602,12.8033009 C13.9748737,12.2175144 13.9748737,11.267767 14.5606602,10.6819805 Z" fill="#000000" opacity="0.3" />
																	<path d="M8.56066017,16.6819805 L10.6819805,14.5606602 C11.267767,13.9748737 12.2175144,13.9748737 12.8033009,14.5606602 L14.9246212,16.6819805 C15.5104076,17.267767 15.5104076,18.2175144 14.9246212,18.8033009 L12.8033009,20.9246212 C12.2175144,21.5104076 11.267767,21.5104076 10.6819805,20.9246212 L8.56066017,18.8033009 C7.97487373,18.2175144 7.97487373,17.267767 8.56066017,16.6819805 Z M8.56066017,4.68198052 L10.6819805,2.56066017 C11.267767,1.97487373 12.2175144,1.97487373 12.8033009,2.56066017 L14.9246212,4.68198052 C15.5104076,5.26776695 15.5104076,6.21751442 14.9246212,6.80330086 L12.8033009,8.9246212 C12.2175144,9.51040764 11.267767,9.51040764 10.6819805,8.9246212 L8.56066017,6.80330086 C7.97487373,6.21751442 7.97487373,5.26776695 8.56066017,4.68198052 Z" fill="#000000" />
																</g>
															</svg> </div>
														<div class="kt-iconbox__desc">
															<h3 class="kt-iconbox__title">
																Get Started
															</h3>
															<div class="kt-iconbox__content">
																Base FAQ Questions
															</div>
														</div>
													</a>
												</div>
											</div>
										</div>
										<div class="col-lg-4">
											<div class="kt-portlet kt-iconbox kt-iconbox--animate">
												<div class="kt-portlet__body">
													<a href="#" class="kt-iconbox__body">
														<div class="kt-iconbox__icon">
															<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
																<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
																	<rect x="0" y="0" width="24" height="24" />
																	<path d="M8,3 L8,3.5 C8,4.32842712 8.67157288,5 9.5,5 L14.5,5 C15.3284271,5 16,4.32842712 16,3.5 L16,3 L18,3 C19.1045695,3 20,3.8954305 20,5 L20,21 C20,22.1045695 19.1045695,23 18,23 L6,23 C4.8954305,23 4,22.1045695 4,21 L4,5 C4,3.8954305 4.8954305,3 6,3 L8,3 Z" fill="#000000" opacity="0.3" />
																	<path d="M10.875,15.75 C10.6354167,15.75 10.3958333,15.6541667 10.2041667,15.4625 L8.2875,13.5458333 C7.90416667,13.1625 7.90416667,12.5875 8.2875,12.2041667 C8.67083333,11.8208333 9.29375,11.8208333 9.62916667,12.2041667 L10.875,13.45 L14.0375,10.2875 C14.4208333,9.90416667 14.9958333,9.90416667 15.3791667,10.2875 C15.7625,10.6708333 15.7625,11.2458333 15.3791667,11.6291667 L11.5458333,15.4625 C11.3541667,15.6541667 11.1145833,15.75 10.875,15.75 Z" fill="#000000" />
																	<path d="M11,2 C11,1.44771525 11.4477153,1 12,1 C12.5522847,1 13,1.44771525 13,2 L14.5,2 C14.7761424,2 15,2.22385763 15,2.5 L15,3.5 C15,3.77614237 14.7761424,4 14.5,4 L9.5,4 C9.22385763,4 9,3.77614237 9,3.5 L9,2.5 C9,2.22385763 9.22385763,2 9.5,2 L11,2 Z" fill="#000000" />
																</g>
															</svg> </div>
														<div class="kt-iconbox__desc">
															<h3 class="kt-iconbox__title">
																Tutorials
															</h3>
															<div class="kt-iconbox__content">
																Books & Articles
															</div>
														</div>
													</a>
												</div>
											</div>
										</div>
										<div class="col-lg-4">
											<div class="kt-portlet kt-iconbox kt-iconbox--animate-fast">
												<div class="kt-portlet__body">
													<a href="#" class="kt-iconbox__body">
														<div class="kt-iconbox__icon">
															<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
																<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
																	<polygon points="0 0 24 0 24 24 0 24" />
																	<path d="M12,11 C9.790861,11 8,9.209139 8,7 C8,4.790861 9.790861,3 12,3 C14.209139,3 16,4.790861 16,7 C16,9.209139 14.209139,11 12,11 Z" fill="#000000" fill-rule="nonzero" opacity="0.3" />
																	<path d="M3.00065168,20.1992055 C3.38825852,15.4265159 7.26191235,13 11.9833413,13 C16.7712164,13 20.7048837,15.2931929 20.9979143,20.2 C21.0095879,20.3954741 20.9979143,21 20.2466999,21 C16.541124,21 11.0347247,21 3.72750223,21 C3.47671215,21 2.97953825,20.45918 3.00065168,20.1992055 Z" fill="#000000" fill-rule="nonzero" />
																</g>
															</svg> </div>
														<div class="kt-iconbox__desc">
															<h3 class="kt-iconbox__title">
																User Guide
															</h3>
															<div class="kt-iconbox__content">
																Complete Knowledgebase
															</div>
														</div>
													</a>
												</div>
											</div>
										</div>
									</div>
								</div>

								<!-- end:: iconbox -->

								<!-- begin:: Section -->
								<div class="kt-container ">
									<div class="kt-portlet">
										<div class="kt-portlet__body">
											<div class="kt-infobox">
												<div class="kt-infobox__header">
													<h2 class="kt-infobox__title">Buying Product & Support</h2>
												</div>
												<div class="kt-infobox__body">
													<div class="row">
														<div class="col-lg-3">
															<ul class="kt-nav kt-nav--bold kt-nav--md-space kt-nav--v4" role="tablist">
																<li class="kt-nav__item">
																	<a class="kt-nav__link" data-toggle="tab" href="#kt_profile_tab_personal_information" role="tab">
																		<span class="kt-nav__link-text">Buying</span>
																	</a>
																</li>
																<li class="kt-nav__item active">
																	<a class="kt-nav__link" data-toggle="tab" href="#kt_profile_tab_personal_information" role="tab">
																		<span class="kt-nav__link-text">Product Support</span>
																	</a>
																</li>
																<li class="kt-nav__item">
																	<a class="kt-nav__link" data-toggle="tab" href="#kt_profile_tab_personal_information" role="tab">
																		<span class="kt-nav__link-text">Account Management</span>
																	</a>
																</li>
																<li class="kt-nav__item">
																	<a class="kt-nav__link" data-toggle="tab" href="#kt_profile_tab_personal_information" role="tab">
																		<span class="kt-nav__link-text">Product Licenses</span>
																	</a>
																</li>
																<li class="kt-nav__item">
																	<a class="kt-nav__link" data-toggle="tab" href="#kt_profile_tab_personal_information" role="tab">
																		<span class="kt-nav__link-text">Downloads</span>
																	</a>
																</li>
															</ul>
														</div>
														<div class="col-lg-7">

															<!--begin::Accordion-->
															<div class="accordion accordion-light  accordion-svg-icon" id="accordionExample7">
																<div class="card">
																	<div class="card-header" id="headingOne7">
																		<div class="card-title" data-toggle="collapse" data-target="#collapseOne7" aria-expanded="true" aria-controls="collapseOne7">
																			<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
																				<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
																					<polygon points="0 0 24 0 24 24 0 24" />
																					<path d="M12.2928955,6.70710318 C11.9023712,6.31657888 11.9023712,5.68341391 12.2928955,5.29288961 C12.6834198,4.90236532 13.3165848,4.90236532 13.7071091,5.29288961 L19.7071091,11.2928896 C20.085688,11.6714686 20.0989336,12.281055 19.7371564,12.675721 L14.2371564,18.675721 C13.863964,19.08284 13.2313966,19.1103429 12.8242777,18.7371505 C12.4171587,18.3639581 12.3896557,17.7313908 12.7628481,17.3242718 L17.6158645,12.0300721 L12.2928955,6.70710318 Z" fill="#000000" fill-rule="nonzero" />
																					<path d="M3.70710678,15.7071068 C3.31658249,16.0976311 2.68341751,16.0976311 2.29289322,15.7071068 C1.90236893,15.3165825 1.90236893,14.6834175 2.29289322,14.2928932 L8.29289322,8.29289322 C8.67147216,7.91431428 9.28105859,7.90106866 9.67572463,8.26284586 L15.6757246,13.7628459 C16.0828436,14.1360383 16.1103465,14.7686056 15.7371541,15.1757246 C15.3639617,15.5828436 14.7313944,15.6103465 14.3242754,15.2371541 L9.03007575,10.3841378 L3.70710678,15.7071068 Z" fill="#000000" fill-rule="nonzero" opacity="0.3" transform="translate(9.000003, 11.999999) rotate(-270.000000) translate(-9.000003, -11.999999) " />
																				</g>
																			</svg> Product Inventory
																		</div>
																	</div>
																	<div id="collapseOne7" class="collapse show" aria-labelledby="headingOne7" data-parent="#accordionExample7">
																		<div class="card-body">
																			Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
																		</div>
																	</div>
																</div>
																<div class="card">
																	<div class="card-header" id="headingTwo7">
																		<div class="card-title collapsed" data-toggle="collapse" data-target="#collapseTwo7" aria-expanded="false" aria-controls="collapseTwo7">
																			<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
																				<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
																					<polygon points="0 0 24 0 24 24 0 24" />
																					<path d="M12.2928955,6.70710318 C11.9023712,6.31657888 11.9023712,5.68341391 12.2928955,5.29288961 C12.6834198,4.90236532 13.3165848,4.90236532 13.7071091,5.29288961 L19.7071091,11.2928896 C20.085688,11.6714686 20.0989336,12.281055 19.7371564,12.675721 L14.2371564,18.675721 C13.863964,19.08284 13.2313966,19.1103429 12.8242777,18.7371505 C12.4171587,18.3639581 12.3896557,17.7313908 12.7628481,17.3242718 L17.6158645,12.0300721 L12.2928955,6.70710318 Z" fill="#000000" fill-rule="nonzero" />
																					<path d="M3.70710678,15.7071068 C3.31658249,16.0976311 2.68341751,16.0976311 2.29289322,15.7071068 C1.90236893,15.3165825 1.90236893,14.6834175 2.29289322,14.2928932 L8.29289322,8.29289322 C8.67147216,7.91431428 9.28105859,7.90106866 9.67572463,8.26284586 L15.6757246,13.7628459 C16.0828436,14.1360383 16.1103465,14.7686056 15.7371541,15.1757246 C15.3639617,15.5828436 14.7313944,15.6103465 14.3242754,15.2371541 L9.03007575,10.3841378 L3.70710678,15.7071068 Z" fill="#000000" fill-rule="nonzero" opacity="0.3" transform="translate(9.000003, 11.999999) rotate(-270.000000) translate(-9.000003, -11.999999) " />
																				</g>
																			</svg> Order Statistics
																		</div>
																	</div>
																	<div id="collapseTwo7" class="collapse" aria-labelledby="headingTwo7" data-parent="#accordionExample7">
																		<div class="card-body">
																			Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
																		</div>
																	</div>
																</div>
																<div class="card">
																	<div class="card-header" id="headingThree7">
																		<div class="card-title collapsed" data-toggle="collapse" data-target="#collapseThree7" aria-expanded="false" aria-controls="collapseThree7">
																			<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" class="kt-svg-icon">
																				<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
																					<polygon points="0 0 24 0 24 24 0 24" />
																					<path d="M12.2928955,6.70710318 C11.9023712,6.31657888 11.9023712,5.68341391 12.2928955,5.29288961 C12.6834198,4.90236532 13.3165848,4.90236532 13.7071091,5.29288961 L19.7071091,11.2928896 C20.085688,11.6714686 20.0989336,12.281055 19.7371564,12.675721 L14.2371564,18.675721 C13.863964,19.08284 13.2313966,19.1103429 12.8242777,18.7371505 C12.4171587,18.3639581 12.3896557,17.7313908 12.7628481,17.3242718 L17.6158645,12.0300721 L12.2928955,6.70710318 Z" fill="#000000" fill-rule="nonzero" />
																					<path d="M3.70710678,15.7071068 C3.31658249,16.0976311 2.68341751,16.0976311 2.29289322,15.7071068 C1.90236893,15.3165825 1.90236893,14.6834175 2.29289322,14.2928932 L8.29289322,8.29289322 C8.67147216,7.91431428 9.28105859,7.90106866 9.67572463,8.26284586 L15.6757246,13.7628459 C16.0828436,14.1360383 16.1103465,14.7686056 15.7371541,15.1757246 C15.3639617,15.5828436 14.7313944,15.6103465 14.3242754,15.2371541 L9.03007575,10.3841378 L3.70710678,15.7071068 Z" fill="#000000" fill-rule="nonzero" opacity="0.3" transform="translate(9.000003, 11.999999) rotate(-270.000000) translate(-9.000003, -11.999999) " />
																				</g>
																			</svg> eCommerce Reports
																		</div>
																	</div>
																	<div id="collapseThree7" class="collapse" aria-labelledby="headingThree7" data-parent="#accordionExample7">
																		<div class="card-body">
																			Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.
																		</div>
																	</div>
																</div>
															</div>

															<!--end::Accordion-->
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								<!-- end:: Section -->

								<!-- begin:: Section -->
								<div class="kt-container ">
									<div class="kt-portlet">
										<div class="kt-portlet__body">
											<div class="kt-infobox">
												<div class="kt-infobox__header">
													<h2 class="kt-infobox__title">AirPlus SAAS License</h2>
												</div>
												<div class="kt-infobox__body">
													<div class="kt-infobox__section">
														<h3 class="kt-infobox__subtitle">Basic License</h3>
														<div class="kt-infobox__content">
															Windows 10 automatically downloads and installs updates to make sure your device is secure and up to date. This means you receive the latest fixes and security updates, helping your device run efficiently and stay protected. In most cases, restarting your device completes the update. Make sure your device is plugged in when you know updates will be installed. <a href="#" class="kt-link">Read More</a>
														</div>
													</div>
													<div class="kt-infobox__section">
														<h3 class="kt-infobox__subtitle">Extended License</h3>
														<div class="kt-infobox__content">
															Windows 10 automatically downloads and installs updates to make sure your device is secure and up to date. This means you receive the latest fixes and security updates, helping your device run efficiently and stay protected. In most cases, restarting your device completes the update. Make sure your device is plugged in when you know updates will be installed. <a href="#" class="kt-link">Read More</a>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								<!-- end:: Section -->

								<!-- begin:: Section -->
								<div class="kt-container ">
									<div class="row">
										<div class="col-lg-6">
											<div class="kt-portlet kt-callout">
												<div class="kt-portlet__body">
													<div class="kt-callout__body">
														<div class="kt-callout__content">
															<h3 class="kt-callout__title">Get in Touch</h3>
															<p class="kt-callout__desc">
																Windows 10 automatically installs updates to make for sure
															</p>
														</div>
														<div class="kt-callout__action">
															<a href="custom/apps/support-center/feedback.html" class="btn btn-custom btn-bold btn-upper btn-font-sm btn-primary">Submit a Request</a>
														</div>
													</div>
												</div>
											</div>
										</div>
										<div class="col-lg-6">
											<div class="kt-portlet kt-callout">
												<div class="kt-portlet__body">
													<div class="kt-callout__body">
														<div class="kt-callout__content">
															<h3 class="kt-callout__title">Live Chat</h3>
															<p class="kt-callout__desc">
																Windows 10 automatically installs updates to make for sure
															</p>
														</div>
														<div class="kt-callout__action">
															<a href="#" data-toggle="modal" data-target="#kt_chat_modal" class="btn btn-custom btn-bold btn-upper btn-font-sm  btn-success">Start Chat</a>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								<!-- end:: Section -->

								<!-- end:: Content -->
							</div>

								<!-- begin::Sticky Toolbar -->
				<app-stickytoolbar></app-stickytoolbar>
		      <!-- end::Sticky Toolbar -->
             </section>         
</div>
</div>
</div>


		